// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import dataTableStyles from "@synd/App/SharedStyles/DataTableStyles";
import { recentOrdersStyles } from "@synd/Overrides/Widgets/Common/RecentOrders";
import LinkArrowRight from "@synd/XDL/Icons/LinkArrowRight";
import { createLinkIconStyles } from "@synd/XDL/Utilities";
import { css } from "styled-components";

recentOrdersStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

recentOrdersStyles.noOrdersFoundText = {
    ...dataTableStyles.noResultsText,
};

recentOrdersStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentOrdersStyles.noOrdersFoundGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentOrdersStyles.ViewAllMyOrders = {
    icon: {
        src: LinkArrowRight,
        position: "right",
    },
    css: css`
        margin-top: 12px;
        display: flex;
        align-items: center;
        ${IconWrapper} {
            top: 0;
            width: 8px;
            height: 13px;

            svg {
                width: 8px;
                height: 10px;
            }
        }
    `,
};

recentOrdersStyles.titleTypographyStyles = {
    link: {
        ...createLinkIconStyles({
            icon: ChevronRight,
            sizeVariant: "small",
            variant: "primary",
            linkStyles: {
                icon: {
                    position: "right",
                },
            },
        }),
    },
};
